import { action } from 'satcheljs';
export default action('ON_SET_END_DATE', function (date) {
    return {
        date: date,
    };
});
//# sourceMappingURL=setEndDate.js.map